import React from "react";
import { Col } from "antd";
import { ArrayOfElements } from "../../../interfaces/common";

interface Props {
  elements: ArrayOfElements;
}

const FormFooter: React.FC<Props> = ({ elements }) => (
  <>
    {elements.map((element) => (
      <Col key={element.key}>{element.element}</Col>
    ))}
  </>
);

export default FormFooter;
